import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import {
  DbLocManufacturer,
  DbLocManufacturerDevicePreview,
} from "../data/manufacturer";
import { DbLocDevice } from "../data/devices";

@Injectable({
  providedIn: "root",
})
export class DataBootStrap {
  devices: DbLocDevice[] | undefined;

  constructor(private http: HttpClient) {
    this.initManufactorDB();
  }

  /**
   * init database with dummy content
   */
  async initManufactorDB(): Promise<DbLocManufacturer[]> {
    let rawData = await firstValueFrom(
      this.http.get("assets/app.devices.data.json", { responseType: "text" })
    );

    const parsedData = JSON.parse(rawData);

    const manufacturers: DbLocManufacturer[] = [];

    if (parsedData.manufacturers && Array.isArray(parsedData.manufacturers)) {
      for (const manuf of parsedData.manufacturers) {
        let m = new DbLocManufacturer();
        m.id = manuf.id;
        m.name = manuf.name;
        m.logo=manuf.logo;
        m.devices = [];

        if (manuf.devices && Array.isArray(manuf.devices)) {
          for (const dd of manuf.devices) {
            const newDevice = new DbLocManufacturerDevicePreview();
            newDevice.id = dd.id;
            newDevice.name = dd.name;
            newDevice.logo= dd.logo;
            newDevice.enDeviceType=dd.enDeviceType;
            newDevice.frDeviceType=dd.frDeviceType;
            newDevice.spDeviceType=dd.spDeviceType;
            newDevice.manufacturer=dd.manufacturer;
            newDevice.completeManufacturersList=dd.completeManufacturersList;
            m.devices.push(newDevice);
          }
        }
        manufacturers.push(m);
      }
    }

    return manufacturers;
  }


  /**
   * preload data from JSON to array of devices
   * @returns 
   */
    async initDeviceDB(): Promise<DbLocDevice[]> {
    const rawData = await firstValueFrom(
      this.http.get("assets/app.devices.data.json", { responseType: "text" })
    );

    const parsedData = JSON.parse(rawData);
    const devices: DbLocDevice[] = [];

    if (parsedData.devices && Array.isArray(parsedData.devices)) {
      for (const dv of parsedData.devices) {
        const d = new DbLocDevice();
        d.id = dv.id;
        d.name = dv.name;
        d.manufacturer = dv.manufacturer;

        d.frDeviceType = dv.frDeviceType;
        d.spDeviceType = dv.spDeviceType;
        d.enDeviceType = dv.enDeviceType;

        d.keywords = dv.keywords ?? [];
        d.completeManufacturersList = dv.completeManufacturersList ?? [];

        d.button1 = dv.button1 ? [dv.button1[0], dv.button1[1]] : undefined;
        d.button2 = dv.button2 ? [dv.button2[0], dv.button2[1]] : undefined;
        d.button3 = dv.button3 ? [dv.button3[0], dv.button3[1]] : undefined;
        d.button4 = dv.button4 ? [dv.button4[0], dv.button4[1]] : undefined;
        d.power = dv.power ? [dv.power[0], dv.power[1]] : undefined;

        d.frSteps = dv.frSteps ?? [];
        d.enSteps = dv.enSteps ?? [];
        d.spSteps = dv.spSteps ?? [];

        d.photoCredits = dv.photoCredits ?? "";
        d.legals = dv.legals ?? "";
        d.photo = dv.photo ?? "";

        devices.push(d);
      }
    }

    this.devices = devices;
    return devices;
  }
}
